<template lang="pug">
  v-sheet(min-height="90vh")
    crud(
      :headers="headers"
      :item.sync="item"
      :items.sync="items"
      :apiService="entityApi"
    )
      template(#filter="{ refreshIndex }")
      template(#form)
        validation-provider(vid="name" v-slot="{ errors }" name="Наименование" rules="required")
          v-text-field(
            v-model="item.name"
            label="Наименование местонахождения"
            :error-messages="errors"
          )
        validation-provider(vid="parent" v-slot="{ errors }" name="Находится в месте")
          v-autocomplete(
            v-model="item.parent.id"
            label="Находится в месте"
            item-value="id"
            item-text="name"
            :items="locationList"
            :error-messages="errors"
            @input="changeParent"
          )
        validation-provider(vid="type" v-slot="{ errors }" name="Категория")
          v-autocomplete(
            v-model="item.type"
            label="Тип"
            item-value="id"
            item-text="name"
            :items="typeList"
            :error-messages="errors"
          )
      template(#item.type="{ item }") {{ typeName(item.type) }}
</template>

<script>
import Crud from '@/components/Crud.vue';
import entityApi from '@/services/api/entityApi';
import { getLocationTypeLabel, LOCATION_TYPE_LABELS } from '@/constants/location/locationType';

export default {
  data() {
    return {
      search: null,
      categoryList: [],
      item: {
        name: null,
        parent: {

        },
        type: null,
      },
      items: [],
      filter: {
        name: null,
        parent: null,
        type: null,
      },
      headers: [
        {
          text: 'Наименование местонахождения',
          value: 'name',
        },
        {
          text: 'Тип',
          value: 'type',
          customValue: true,
        },
        {
          text: 'Находится в месте',
          value: 'parent.name',
        },
      ],
    };
  },
  watch: {
  },
  computed: {
    customizer() {
      return {
        type: (value) => getLocationTypeLabel(value),
      };
    },
    entityApi() {
      return entityApi.location;
    },
    typeList() {
      return LOCATION_TYPE_LABELS;
    },
    locationList() {
      return this.items;
    },
  },
  components: {
    Crud,
  },
  name: 'Location',
  created() {
  },
  methods: {
    typeName(type) {
      return getLocationTypeLabel(type);
    },
    changeParent() {
      const [newParent] = this.locationList.filter((parent) => parent.id === this.item.parent.id);
      this.item.parent = newParent;
    },
  },
};
</script>

<style scoped>

</style>
